import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-full-size',
  templateUrl: './image-full-size.component.html',
  styleUrls: ['./image-full-size.component.scss']
})
export class ImageFullSizeComponent {

	/** Form Group */
	dialogForm: FormGroup;

	/**
     * Default Constructor
	 * @param fb Form Builder
     * @param dialogRef Referense to the Dialog box
     * @param dialogData  object interface
     */
    constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<ImageFullSizeComponent>,
        @Inject(MAT_DIALOG_DATA) public srcImage: String,
    ) { }

	onCloseClick(): void {
		this.dialogRef.close();
	  }

}
